import { from, merge, Observable } from 'rxjs';
import { Action } from 'redux';
import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import { StorageActions, StorageMsg } from '@wearejh/m2-pwa-engine/lib/storage/storage.actions';

import { STORAGE_KEY, UserActions } from '../user.actions';

export function resetUserState(action$: Observable<any>): Observable<Action> {
    const signOut$ = action$.pipe(ofType<UserActions>('User.SignOut'));
    const userReset$ = action$.pipe(ofType<UserActions>('User.Reset'));
    /**
     * Merge the streams to perform the sign-out on both
     */
    return merge(signOut$, userReset$).pipe(
        mergeMap(() =>
            from([
                StorageMsg(StorageActions.Delete, STORAGE_KEY),
                StorageMsg(StorageActions.DeleteCookie, STORAGE_KEY),
            ]),
        ),
    );
}
